import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';
import { toast } from 'react-toastify';

export const { setDataProcessingGroupByData, setDataProcessingGroupByStatus } = slice.actions;

const dataProcessingGroupBy = (params: any, url: any) => async () => {
  try {
    const response = await API.dataProcessingGroupBy.dataProcessingGroupBy(params, url);
    dispatch(setDataProcessingGroupByData(response.data));
    dispatch(setDataProcessingGroupByStatus(response.status));
    return { response, status: response.status, data: response.data };
  } catch (error: any) {
    if (error.response.status === 422) {
      toast.error(error.response.data.message);
    }
  }
};

export default {
  dataProcessingGroupBy
};
